import { AuthStatus } from "../service/UrlResolver";
import store from "../store/store";
import { setAuthStatus, setAccessToken } from "../common/actions";
import { TeamSitePageContentCall } from "../service/TeamSiteService";
import { getDataFromAPI } from "../service";
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { getCookie } from '../utils/AEMUtils';
import { AUTH_COOKIE_STORE } from '../common/constant';
import Cookies from 'js-cookie';


const { REACT_APP_SERVICE_URL } = window.weeksWebCloudConfig;
const context = JSON.parse(getCookie('AEM_POST_FLAG'));
const loggedIn = JSON.parse(getCookie('_barrierrciapp_'));

const isAuthenticated = () => {
  let tokenRes = '';
  AuthStatus().then(serviceRes => {
    /* if(process.env.NODE_ENV === "development"){
     serviceRes = { error_code: "401",
     error_desc: "Unauthorized",
     error_detail: "Invalid token: policy(Verify-JWT-Token)",
     locale: "en_GB",
     memberId: "1179899001",
     valid: "true"}
    } */
    /* if(process.env.NODE_ENV === "development"){
     serviceRes = { error_code: "401",
     error_desc: "Unauthorized",
     error_detail: "Invalid token: policy(Verify-JWT-Token)",
     locale: "en_US",
     memberId: "601461001",
     valid: "true"}
    } */
    if (!isEmpty(loggedIn)) {
      serviceRes = loggedIn;
    }
    if (serviceRes.valid === "true") {

      //tokenRes=authtokenRes;
      const TeamSitePageContentCallPromise = new Promise((resolve, reject) => {
        if (!context) {
          TeamSitePageContentCall(serviceRes.memberId, serviceRes.locale).then(temsiteRes => {
              store.dispatch({ type: "SET_PAGE_CONTENT_DATA", payload: temsiteRes.Page });
            //store.dispatch(setAccessToken(tokenRes.data.access_token));
            resolve();
          })
        } else {
          resolve();
        }
      });
      const customerProfilePromise = new Promise((resolve, reject) => {
        getDataFromAPI(`${REACT_APP_SERVICE_URL}/rcio/utility/teamsite/customer-profile?customerid=` + serviceRes.memberId, 'GET', serviceRes.memberId, '').then(res => {
          if (res && res.status === 200) {
            store.dispatch({ type: 'SET_CUSTOMER_PROFILE', payload: res.data });
            window.SubscriberId = get(res.data, 'subscriberId', '');
            window.SecondaryId = get(res.data, 'leadId', '');
            window.brandCode = get(res.data, 'brandCode', '');
            window.currentLocale = get(res.data, 'locale', '');
            window.opinionLocale = get(res.data, 'locale', '');
            window.memberTier = get(res.data, 'memberTierType', '');
            window.MemberStatus = get(res.data, 'memberStatus', '');
            resolve();
          } else {
            reject();
            localStorage.removeItem('loginFormMessage');
            Cookies.remove(AUTH_COOKIE_STORE);
            window.location.href = "/signout";

          }
        });
      });
      Promise.all([TeamSitePageContentCallPromise, customerProfilePromise]).then((values) => {
        store.dispatch(setAuthStatus(serviceRes));
      });
    }
    else {
      store.dispatch(setAuthStatus(serviceRes));

    }

  });
};
export default isAuthenticated;
 